import { render, staticRenderFns } from "./CollectionReport.vue?vue&type=template&id=5d0fb3a2&"
import script from "./CollectionReport.vue?vue&type=script&lang=js&"
export * from "./CollectionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports